import Result from '@/components/Results/Result';
import QuestionArray from '@/components/Question/QuestionArray';

export default class ResultArray {
    get all(): Result[] {
        return this._list;
    }

    private readonly _list: Result[] = [];

    constructor(list?: ResultArray | Result[]) {
        this.fill(list);
    }

    public fill(list?: ResultArray | Result[], limit: number = 0) {
        let Results!: Result[];

        if (list && list instanceof ResultArray) {
            Results = list.all;
        } else if (list) {
            Results = list;
        }

        if (Results) {
            if (limit > 0 && limit < Results.length) {
                Results = Results.splice(0, limit);
            }

            for (const item of Results) {
                this.add(item);
            }
        }

    }

    public fromJSON(items: any) {
        if (Array.isArray(items)) {
            for (let item of items) {
                if (item._time && item._title && item._date && item._errorsCount && item._answersCount) {
                    try {
                        const questions: QuestionArray = new QuestionArray(item._questions._list);
                        this.add(new Result(questions, item._time, item._title, item._errorsCount, item._answersCount, item._date,));
                    } catch (e) {
                        console.error(e);
                    }
                }
            }
        }
    }

    public refresh(list?: ResultArray | Result[]) {
        this.clear();
        this.fill(list);
    }

    public add(item: Result) {
        this._list.push(item);
        this.sort();
    }

    public sort() {
        this._list.sort((a: Result, b: Result) => {
            const date_a: Date = a.date;
            const date_b: Date = b.date;

            if (date_a < date_b) {
                return 1;
            } else if (date_b < date_a) {
                return -1;
            } else {
                return 0;
            }
        });
    }

    public clear() {
        this._list.splice(0);
    }

    get length(): number {
        return this._list.length;
    }

    get(index: number): Result {
        if (index > -1) {
            return this._list[index];
        } else {
            throw Error(`Wrong index: ${index}`);
        }
    }

    get last(): Result | null {
        this.sort();

        if (this.length > 0) {
            return this.get(this.length - 1);
        } else {
            return null;
        }
    }
}
